<template>
  <div class="progress-stat-card" :class="cardClasses">
    <h3>{{ config.title }}</h3>
    <p>Progress card coming soon...</p>
  </div>
</template>

<script>
export default {
  name: "ProgressStatCard",
  props: {
    config: { type: Object, required: true },
    data: { type: Object, default: () => ({}) }
  },
  computed: {
    cardClasses() {
      return ["bg-white", "rounded-xl", "shadow-sm", "border", "p-6"];
    }
  }
};
</script>
